import "twin.macro";

import { useWatch } from "react-hook-form";
import { Link } from "react-router";

import { Button, Typography } from "@mui/material";

import { ResourceError } from "@features/errors";
import { QuoteStatus, usePaginatedQuoteQuery } from "@features/quotes";
import { NewRfqButton } from "@features/rfqs";
import { DateFromNow } from "@features/ui";
import { utcToLocalDate } from "@utility/utilityFunctions";

import BlockCard, { BlockCardActions } from "../../../ui/BlockCard";

const Quotes = () => {
  const id = useWatch({ name: "id" });
  const {
    data: quotes,
    error,
    isLoading,
  } = usePaginatedQuoteQuery({
    filter: { itemId: id, status: ["sent", "accepted", "complete", "awarded"] },
    sort: "-updated-at",
  });

  return (
    <BlockCard title="Quotes">
      {error && <ResourceError error={error} />}
      {!isLoading && quotes.length === 0 && (
        <p tw="text-neutral-600 font-light">
          This item doesn't have any quotes.
        </p>
      )}
      <div tw="-mt-2 -mx-6 px-3 max-h-48 overflow-y-auto">
        {quotes.map((quote) => (
          <Link
            to={
              quote.isComplete
                ? `/quotes/${quote.id}`
                : `/rfqs/${quote.requestForQuote.id}`
            }
            key={quote.id}
            tw="block px-3 mt-3"
          >
            <div tw="flex items-center justify-between gap-2">
              <Typography noWrap tw="font-medium text-base">
                {quote.supplierName}
              </Typography>
              <QuoteStatus status={quote.status} />
            </div>
            <DateFromNow
              date={utcToLocalDate(quote.updatedAt)}
              tw="text-sm text-neutral-500"
            />
          </Link>
        ))}
      </div>
      <BlockCardActions>
        <NewRfqButton
          tw="normal-case py-1 shadow-none hover:(shadow-none bg-neutral-100!)"
          itemId={id}
        />
        <Button variant="outlined" component={Link} to={`/rfqs/item/${id}`}>
          View All
        </Button>
      </BlockCardActions>
    </BlockCard>
  );
};

export default Quotes;
